import { gql } from 'apollo-boost';

export const VALIDATE_GROQ_KEY = gql`
    mutation ValidateGroqKey {
        validateGroqKey {
            __typename
            ... on SetGroqKeySuccess {
                success
                status
            }
            ... on GroqKeyError {
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
